var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.67 -1.67 15.34 15.34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    d: "M.887 4.409a6 6 0 0 0-.053.777c0 2.946 2.239 5.334 5 5.334s5-2.388 5-5.334q0-.396-.053-.777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.834 6.075V.52m0 5.555c-.389 0-1.116-1.108-1.389-1.389m1.39 1.39c.388 0 1.115-1.109 1.388-1.39"
  })));
};
export default SvgDownload;